// extracted by mini-css-extract-plugin
export default {"card":"Card_card__4-jbm","category":"Card_category__5-KBV","content":"Card_content__HOJRd","title":"Card_title__HynCQ","tagContainer":"Card_tagContainer__I-Tmd"};